import {
  GitMergeIcon,
  GitPullRequestClosedIcon,
  GitPullRequestDraftIcon,
  GitPullRequestIcon,
} from '@primer/octicons-react'

export function getPRStatusIcon(status: string) {
  switch (status) {
    case 'draft':
      return <GitPullRequestDraftIcon className="fgColor-draft" />
    case 'open':
      return <GitPullRequestIcon className="fgColor-open" />
    case 'closed':
      return <GitPullRequestClosedIcon className="fgColor-closed" />
    case 'merged':
      return <GitMergeIcon className="fgColor-done" />
    default:
      return <GitPullRequestIcon className="fgColor-open" />
  }
}
